import { render, staticRenderFns } from "./ArticleZincCoatingEditDialog.vue?vue&type=template&id=c0e0234e&scoped=true"
import script from "./ArticleZincCoatingEditDialog.vue?vue&type=script&lang=ts"
export * from "./ArticleZincCoatingEditDialog.vue?vue&type=script&lang=ts"
import style0 from "./ArticleZincCoatingEditDialog.vue?vue&type=style&index=0&id=c0e0234e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0e0234e",
  null
  
)

export default component.exports